export default __webpack_public_path__ + "static/media/ttdrahmi.6b67b1c2.png";